// File: src/components/pages/Dashboard.jsx
// Role router — dispatches to StudentDashboard, InstructorDashboard, or AdminDashboard

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_NAMESPACE, ROLES } from '../../utils/constants';
import StudentDashboard from './StudentDashboard';
import InstructorDashboard from './InstructorDashboard';
import AdminDashboard from './admin/AdminDashboard';
import { useStudentAuth } from '../../context/StudentAuthContext';
import { useAuthToken } from '../../hooks/useAuthToken';
import { getStudentName } from '../../services/cognitoAuth';

const Dashboard = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const { isStudentAuthenticated } = useStudentAuth();
  // Auth0 token when an Auth0 session is active, Cognito token otherwise —
  // StudentDashboard/InstructorDashboard don't need to know which.
  const getToken = useAuthToken();

  // A Cognito session is, by construction, always a student (this route is
  // only reachable this way via the student-only branch in App.js) — takes
  // priority over the Auth0 checks below, which won't fire anyway since
  // there's no Auth0 user in this case.
  if (isStudentAuthenticated) {
    return (
      <StudentDashboard
        user={{ name: getStudentName() }}
        getAccessTokenSilently={getToken}
      />
    );
  }

  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isStudent = userRoles.includes(ROLES.SERVICEUSER);
  const isInstructor = userRoles.includes(ROLES.SERVICEPROVIDER);
  const isAdmin = userRoles.includes(ROLES.ADMIN);

  if (isStudent) {
    return <StudentDashboard user={user} getAccessTokenSilently={getToken} />;
  }
  if (isInstructor) {
    return <InstructorDashboard user={user} getAccessTokenSilently={getToken} />;
  }
  if (isAdmin) {
    return <AdminDashboard />;
  }
};

export default Dashboard;